export default "__VITE_ASSET__Bg_j37jc__"